<template>
  <div class="campus-sifu">
    <p><strong>CAMPUS SIFU</strong></p>

    <p>
      Además de las formaciones presenciales, contamos con campus formativo propio
      para formaciones virtuales u online.
    </p>

    <strong>PORTAL ALUMNO :</strong>
     <a href="https://gruposifugestor.iformalia.es/loginAlumno.html?acceso=Alumno&QXV0b0xvZ2luPQ==" class="btn">Acceso </a>
     
    <p>
      En él podrás encontrar las formaciones que estás cursando y el histórico de
      formaciones finalizadas.
    </p>

    <p>
      <em>
        Si no recuerdas tus claves de acceso, contacta con
        <a href="mailto:formacion@gruposifu.com">formacion@gruposifu.com</a>
      </em>
    </p>

    <p>
      Disponemos de un <strong>catálogo</strong> abierto para empleados/as de servicios.
    </p>

    <p><strong>CATÁLOGO:</strong></p>

    <p>Grupo SIFU: 900 447 447</p>
    <p><strong>CATÁLOGO:</strong></p>

    <p>
      Inscripción:
      <a
        href="https://forms.office.com/e/JAiSGKHtCK"
        target="_blank"
      >
        https://forms.office.com/e/JAiSGKHtCK
      </a>
    </p>

    <p>
      Contacto:
      <a href="mailto:formacion@gruposifu.com">formacion@gruposifu.com</a>
    </p>



  </div>
</template>

<style scoped>
.campus-sifu {
  line-height: 1.6;
  font-size: 14px;
}

.campus-sifu img {
  max-width: 100%;
  margin: 16px 0;
}
.btn{
  background-color:#007BFF;
  color:white;
  padding:10px 20px;
  text-decoration:none;
  border-radius:5px;
  font-family:Arial;
}
</style>





